<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'SETTINGS.SETTINGS' | transloco">
    <sbnb-settings-subnav></sbnb-settings-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists profile" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <ng-container navTabs>
        <sbnb-page-header class="absolute"></sbnb-page-header>
        <h2 fxLayout fxLayoutAlign="space-apart center">
          <span fxFlex class="text-center sbnbDesktop:text-left">Personal Info</span>
          <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
        </h2>
      </ng-container>
      <h2 fxLayout fxLayoutAlign="space-apart center">
        <span fxFlex>Personal Info</span>
        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </h2>
    </app-feature-flag-tabs>

    <sbnb-android-prominent-disclosure style="margin-bottom: 24px"></sbnb-android-prominent-disclosure>

    <mat-spinner *ngIf="loading" [diameter]="32"></mat-spinner>

    <form *ngIf="!loading" [formGroup]="profileForm">
      <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="8px">
        <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Picture</strong>
        <div fxFlex="300px" fxFlex.lt-md="none">
          <ng-picker-overlay
            [pickerOptions]="{
              maxFiles: 1,
              maxSize: 1 * 1024 * 1024,
              fromSources: ['local_file_system', 'url'],
              accept: ['image/jpeg', 'image/png']
            }"
            (uploadSuccess)="onPictureUploadSuccess($event)">
            <div class="profile-container">
              <img
                class="profile-img"
                [src]="profileData.picture"
                onerror="this.src='/assets/images/profile-default.png'" />
              <div class="edit-icon">
                <mat-icon>edit</mat-icon>
              </div>
              <span class="edit-btn strong">Edit</span>
            </div>
          </ng-picker-overlay>
        </div>
      </div>

      <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="8px">
        <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">First name</strong>
        <div fxFlex="300px" fxFlex.lt-md="none">
          <mat-form-field class="input__mini fw">
            <input matInput formControlName="firstName" />
            <mat-error *ngIf="profileForm.get('firstName').hasError('required')">First name is required</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="8px">
        <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Last name</strong>
        <div fxFlex="300px" fxFlex.lt-md="none">
          <mat-form-field class="input__mini fw">
            <input matInput formControlName="lastName" />
            <mat-error *ngIf="profileForm.get('lastName').hasError('required')">Last name is required</mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Email change request warning -->
      <ng-container *ngIf="emailChangeRequests$ | async as newEmail">
        <div *ngIf="newEmail?.email" class="warning" fxLayoutGap="16px" fxLayoutAlign="start">
          <img src="assets/iconography/warning.svg" width="20px" height="20px" fxFlex="0 0 20px" />
          <div>
            We received a request to change your email to
            <strong>{{ newEmail?.email }}</strong>
            . Check your email to verify the change.
          </div>
        </div>
      </ng-container>

      <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="8px">
        <strong class="profile__label" fxFlex.lt-md="none" fxFlex="170px">Email</strong>
        <div fxFlex.lt-md="none" fxFlex="300px">
          <mat-form-field class="input__mini fw">
            <input matInput formControlName="email" />
            <mat-hint>You will receive all our emails to this address</mat-hint>
            <mat-error *ngIf="profileForm.get('email').hasError('required')">Email is required</mat-error>
            <mat-error *ngIf="profileForm.get('email').hasError('email')">Please enter a valid email address</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="8px">
        <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Phone</strong>
        <div fxFlex.lt-md="none" fxFlex="300px">
          <mat-form-field class="fw input__mini">
            <ngx-mat-intl-tel-input
              [enablePlaceholder]="true"
              [preferredCountries]="preferredCountries"
              name="mobile_phone"
              formControlName="phone"
              placeholder="optional"
              #phone></ngx-mat-intl-tel-input>

            <mat-hint>Eg. {{ phone.selectedCountry.placeHolder }}</mat-hint>
            <mat-error *ngIf="profileForm.get('phone').hasError('validatePhoneNumber')">
              Please enter a valid phone number
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <sbnb-button
        size="mini"
        style="display: block; margin-top: 24px"
        [loading]="saving"
        [disabled]="!profileForm.valid"
        (clicked)="save()">
        Save changes
      </sbnb-button>
    </form>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Settings'">
  <sbnb-settings-subnav></sbnb-settings-subnav>
</sbnb-mobile-sidebar>
